export const addProgressToSites = sites => {
  return sites.map(site => {
    const { sitePreferences } = site || {}
    const { k5Digital = {}, mspDigital = {} } = sitePreferences || {}
    let planProgressNumber = 0
    let planProgressStatus = 'Not Started'
    let launchProgressNumber = 0
    let launchProgressStatus = 'Not Started'

    if (
      (k5Digital?.implementationType || mspDigital?.implementationType) &&
      (k5Digital?.counselorLed || k5Digital?.teacherLed) &&
      (k5Digital?.programIsEnabled || mspDigital?.programIsEnabled)
    ) {
      planProgressNumber++
    }

    if (k5Digital?.purposeIsCompleted || mspDigital?.purposeIsCompleted) {
      planProgressNumber++
    }

    if (
      (k5Digital?.classCreationGoalDateIsCompleted &&
        k5Digital?.classCreationGoalValueIsCompleted &&
        k5Digital?.lessonCompletionGoalDateIsCompleted &&
        k5Digital?.lessonCompletionGoalValueIsCompleted) ||
      (mspDigital?.classCreationGoalDateIsCompleted &&
        mspDigital?.classCreationGoalValueIsCompleted &&
        mspDigital?.lessonCompletionGoalDateIsCompleted &&
        mspDigital?.lessonCompletionGoalValueIsCompleted)
    ) {
      planProgressNumber++
    }

    if (k5Digital?.programStartDate || mspDigital?.programStartDate) {
      planProgressNumber++
    }

    if (k5Digital.userInvitationMethod || mspDigital.userInvitationMethod) {
      launchProgressNumber++
    }

    if (k5Digital.kickoffPrepared || mspDigital.kickoffPrepared) {
      launchProgressNumber++
    }

    if (k5Digital.kickoffHosted || mspDigital.kickoffHosted) {
      launchProgressNumber++
    }

    if (k5Digital.familyLetterSent || mspDigital.familyLetterSent) {
      launchProgressNumber++
    }

    if (planProgressNumber === 4) {
      planProgressStatus = 'Complete'
    } else if (planProgressNumber > 0) {
      planProgressStatus = 'In Progress'
    }

    if (launchProgressNumber === 4) {
      launchProgressStatus = 'Complete'
    } else if (launchProgressNumber > 0) {
      launchProgressStatus = 'In Progress'
    }

    return {
      ...site,
      planProgressNumber,
      planProgressStatus,
      launchProgressNumber,
      launchProgressStatus,
    }
  })
}
